import React, { useState } from "react";
  const campCenters = ["Shirur", "Ulwe", "Akola","Thane","Rahuri"];

  const sources = [
    {
      value: "offline",
      label: "Offline",
      icon: "📍",
    },
    
    {
      value: "digital-marketing",
      label: "Digital Marketing",
      icon: "📱",
    },
  ];
function App() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    age: "",
   
    source: "",
    campCenter: "", 
  });
  const [statusMessage, setStatusMessage] = useState({
  show: false,
  type: "",
  title: "",
  description: "",
});

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);



  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Please enter your name";
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit mobile number";
    }

    if (!formData.age) {
      newErrors.age = "Please enter your age";
    } else if (Number(formData.age) < 18 || Number(formData.age) > 100) {
      newErrors.age = "Age must be between 18 and 100";
    }

    // if (!formData.location.trim()) {
    //   newErrors.location = "Please enter your location";
    // }

    if (!formData.source) {
      newErrors.source = "Please select how you heard about us";
    }

    if (!formData.campCenter) {
      newErrors.campCenter = "Please select a camp center";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit =async (e) => {
    e.preventDefault();

    if (!validate()) return;

    console.log("Camp Registration:", formData);

  
  try {
  const resp = await fetch(
    "https://backendfree.prevoirivf.com/api/camp",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: formData.name,
        phone: formData.phone,
        age: formData.age,
        
        source: formData.source,
        camp_center: formData.campCenter,
      }),
    }
  );

  const data = await resp.json();

  if (!resp.ok) {
    throw new Error(data.message || "Registration failed");
  }

  console.log("Registration saved:", data);

setStatusMessage({
  show: true,
  type: "success",
  title: data.title || "Registration successful!",
  description:
    data.description || "Thank You.",
});
  setFormData({
    name: "",
    phone: "",
    age: "",
    location: "",
    source: "",
    campCenter: "",
  });


} catch (error) {
  console.error("Registration error:", error);
  setStatusMessage({
    show: true,
    type: "error",
    title: "Registration failed",
    description:
      error.message ||
      "Something went wrong. Please try again.",
  });
}


 
  };

  return (
    <div className="min-h-screen bg-tertiary px-4 py-6 sm:px-6 lg:px-10 lg:py-10">
      <div className="mx-auto max-w-6xl overflow-hidden rounded-3xl bg-white shadow-[0_20px_60px_rgba(0,0,0,0.10)]">

      <div className="grid lg:grid-cols-2 ">

          {/* ================= LEFT SIDE ================= */}
       {/* ================= LEFT SIDE ================= */}
<div className="relative w-full bg-primary">
  <div className="flex relative w-full items-center justify-center rounded-lg">
      <div className="pointer-events-none absolute inset-0 bg-primary/10" />

    <picture className="  block w-full">
    
      {/* Tablet and Desktop - md and above */}
      <source
       media="(min-width: 1024px)"
        srcSet="/mobail%20banner%20(1).jpg"
      />

      {/* Mobile - below md */}
      <img
        src="/desktop%20banner.jpg"
        alt="Prevoir IVF fertility consultation"
        className="block h-auto w-full object-contain"
      />

    </picture>
  </div>
</div>




          {/* ================= RIGHT SIDE ================= */}
          <div className="px-6 sm:px-10 lg:px-12 py-4 lg:py-0">

            {/* Header */}
            <div className="">

             
              <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
             Free IVF Registration
              </h2>

              <p className="mt-3 max-w-lg text-sm leading-6 text-gray-500">
               Fill out the details below to register your free fertility consultation.
              </p>

            </div>

          {statusMessage.show && (
  <div
    className={`mb-6 flex items-start gap-3 rounded-xl border p-4 ${
      statusMessage.type === "success"
        ? "border-green-200 bg-green-50 text-green-700"
        : "border-red-200 bg-red-50 text-red-700"
    }`}
  >
    {/* Icon */}
    <div
      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs text-white ${
        statusMessage.type === "success"
          ? "bg-green-600"
          : "bg-red-600"
      }`}
    >
      {statusMessage.type === "success" ? "✓" : "!"}
    </div>

    {/* Content */}
    <div>
      <p className="text-sm font-bold">
        {statusMessage.title}
      </p>

      <p
        className={`mt-1 text-xs ${
          statusMessage.type === "success"
            ? "text-green-600"
            : "text-red-600"
        }`}
      >
        {statusMessage.description}
      </p>
    </div>
  </div>
)}

            <form onSubmit={handleSubmit}>

              {/* ================= PERSONAL DETAILS ================= */}
              <div className="mb-8">

                <div className="mb-5 flex items-center gap-3">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-sm font-bold text-white">
                    01
                  </div>

                  <div>
                    <h3 className="text-sm font-bold text-gray-900">
                      Personal Details
                    </h3>
                    <p className="text-xs text-gray-400">
                      Tell us a little about yourself
                    </p>
                  </div>
                </div>

                <div className="grid gap-5 sm:grid-cols-2">

                  {/* Name */}
                  <div className="sm:col-span-2">
                    <label className="mb-2 block text-xs font-bold uppercase tracking-wide text-gray-600">
                      Full Name
                      <span className="ml-1 text-primary">*</span>
                    </label>

                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      className={`w-full rounded-xl border bg-gray-50 px-4 py-3.5 text-sm text-gray-900 outline-none transition placeholder:text-gray-400 focus:bg-white focus:ring-4 focus:ring-primary/5 ${
                        errors.name
                          ? "border-red-400"
                          : "border-gray-200 focus:border-primary"
                      }`}
                    />

                    {errors.name && (
                      <p className="mt-1.5 text-xs text-red-500">
                        {errors.name}
                      </p>
                    )}
                  </div>

                  {/* Phone */}
                  <div>
                    <label className="mb-2 block text-xs font-bold uppercase tracking-wide text-gray-600">
                      Phone Number
                      <span className="ml-1 text-primary">*</span>
                    </label>

                    <div className="flex overflow-hidden rounded-xl border border-gray-200 bg-gray-50 focus-within:border-primary focus-within:bg-white focus-within:ring-4 focus-within:ring-primary/5">

                     

                      <input
                        type="number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        maxLength="10"
                        inputMode="numeric"
                        placeholder="9876543210"
                        className="w-full bg-transparent px-3 py-3.5 text-sm outline-none"
                      />

                    </div>

                    {errors.phone && (
                      <p className="mt-1.5 text-xs text-red-500">
                        {errors.phone}
                      </p>
                    )}
                  </div>

                  {/* Age */}
                  <div>
                    <label className="mb-2 block text-xs font-bold uppercase tracking-wide text-gray-600">
                      Age
                      <span className="ml-1 text-primary">*</span>
                    </label>

                    <input
                      type="number"
                      name="age"
                      value={formData.age}
                      onChange={handleChange}
                      min="18"
                      max="100"
                      placeholder="Your age"
                      className={`w-full rounded-xl border bg-gray-50 px-4 py-3.5 text-sm outline-none transition placeholder:text-gray-400 focus:bg-white focus:ring-4 focus:ring-primary/5 ${
                        errors.age
                          ? "border-red-400"
                          : "border-gray-200 focus:border-primary"
                      }`}
                    />

                    {errors.age && (
                      <p className="mt-1.5 text-xs text-red-500">
                        {errors.age}
                      </p>
                    )}
                  </div>

                  {/* Location */}
                  {/* <div className="sm:col-span-2">
                    <label className="mb-2 block text-xs font-bold uppercase tracking-wide text-gray-600">
                      Location
                      <span className="ml-1 text-primary">*</span>
                    </label>

                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      placeholder="City / Area"
                      className={`w-full rounded-xl border bg-gray-50 px-4 py-3.5 text-sm outline-none transition placeholder:text-gray-400 focus:bg-white focus:ring-4 focus:ring-primary/5 ${
                        errors.location
                          ? "border-red-400"
                          : "border-gray-200 focus:border-primary"
                      }`}
                    />

                    {errors.location && (
                      <p className="mt-1.5 text-xs text-red-500">
                        {errors.location}
                      </p>
                    )}
                  </div> */}

                </div>
              </div>

              {/* ================= CAMP CENTER ================= */}
              {/* <div className="mb-8">

                <div className="mb-5 flex items-center gap-3">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-sm font-bold text-white">
                    02
                  </div>

                  <div>
                    <h3 className="text-sm font-bold text-gray-900">
                      Choose Camp Center
                    </h3>
                    <p className="text-xs text-gray-400">
                      Select your preferred location
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-3">

                  {campCenters.map((center) => {
                    const selected =
                      formData.campCenter === center;

                    return (
                      <button
                        key={center}
                        type="button"
                        onClick={() => {
                          setFormData((prev) => ({
                            ...prev,
                            campCenter: center,
                          }));

                          setErrors((prev) => ({
                            ...prev,
                            campCenter: "",
                          }));
                        }}
                        className={`relative rounded-xl border px-3 py-4 text-center transition ${
                          selected
                            ? "border-primary bg-primary text-white shadow-lg shadow-primary/20"
                            : "border-gray-200 bg-gray-50 text-gray-700 hover:border-primary/40 hover:bg-white"
                        }`}
                      >

                        {selected && (
                          <span className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-white text-[10px] font-bold text-primary">
                            ✓
                          </span>
                        )}

                        <div className="text-xl">📍</div>

                        <p className="mt-2 text-sm font-bold">
                          {center}
                        </p>

                      </button>
                    );
                  })}

                </div>

                {errors.campCenter && (
                  <p className="mt-2 text-xs text-red-500">
                    {errors.campCenter}
                  </p>
                )}

              </div> */}
              
              <div className="mb-8">
                <div className="mb-5 flex item-center gap-3"> 
                
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-sm font-bold text-white">
                    02
                  </div>
                    <div>
                      <h3 className="text-sm font-bold text-gray-900"> Choose Camp Center</h3>
                      <p className="text-xs text-gray-400">  Select your preferred location</p>
                    </div>
                  

                </div>
                <div className="grid grid-cols-3 gap-3">
                  {
                    campCenters.map((item,index)=>
                      {
                        const selected=formData.campCenter==item
                        return(
                          <button key={index}   className={`relative rounded-xl border px-3 py-4 text-center transition ${
                          selected
                            ? "border-primary bg-primary text-white shadow-lg shadow-primary/20"
                            : "border-gray-200 bg-gray-50 text-gray-700 hover:border-primary/40 hover:bg-white"
                        }`}
                           onClick={()=>
                          {
                            setFormData((prev)=>({
                              ...prev,
                              campCenter:item
                            }))
                            setErrors((prev)=>({
                              ...prev,
                              campCenter:""
                            }))
                          }
                          }>
                            {item}
                          </button>
                        )

                    })
                  }
                       {errors.campCenter && (
                      <p className="mt-1.5 text-xs text-red-500">
                        {errors.campCenter}
                      </p>
                    )}

                </div>

              </div>

              {/* ================= SOURCE ================= */}
              <div className="mb-8">

                <div className="mb-5 flex items-center gap-3">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-sm font-bold text-white">
                    03
                  </div>

                  <div>
                    <h3 className="text-sm font-bold text-gray-900">
                      How did you hear about us?
                    </h3>
                    <p className="text-xs text-gray-400">
                      Help us understand your source
                    </p>
                  </div>
                </div>

                <div className="grid gap-3 sm:grid-cols-3">

                  {sources.map((source) => {
                    const selected =
                      formData.source === source.value;

                    return (
                      <button
                        key={source.value}
                        type="button"
                        onClick={() => {
                          setFormData((prev) => ({
                            ...prev,
                            source: source.value,
                          }));

                          setErrors((prev) => ({
                            ...prev,
                            source: "",
                          }));
                        }}
                        className={`flex items-center gap-3 rounded-xl border p-3 text-left transition ${
                          selected
                            ? "border-secondary bg-secondary/10 ring-1 ring-secondary"
                            : "border-gray-200 bg-gray-50 hover:border-secondary/50 hover:bg-white"
                        }`}
                      >

                        <span className="text-xl">
                          {source.icon}
                        </span>

                        <span
                          className={`text-xs font-bold ${
                            selected
                              ? "text-gray-900"
                              : "text-gray-600"
                          }`}
                        >
                          {source.label}
                        </span>

                      </button>
                    );
                  })}

                </div>

                {errors.source && (
                  <p className="mt-2 text-xs text-red-500">
                    {errors.source}
                  </p>
                )}

              </div>

              {/* ================= SUBMIT ================= */}
              <div>

                <button
                  type="submit"
                  className="group flex w-full items-center justify-center gap-3 rounded-xl bg-primary px-6 py-4 text-sm font-bold text-white shadow-lg shadow-primary/20 transition hover:-translate-y-0.5 hover:bg-[#8f111a] hover:shadow-xl"
                >
                  Register for Fertility Camp

                  <span className="transition-transform group-hover:translate-x-1">
                    →
                  </span>
                </button>

                <div className="mt-5 flex items-center justify-center gap-2 text-center">
                  <span className="text-green-600">🔒</span>

                  <p className="text-[11px] leading-5 text-gray-400">
                    Your information is private and will only be used
                    for appointment coordination.
                  </p>
                </div>

              </div>

            </form>
          </div>

        </div>
      </div>
    </div>
  );
}

export default App;
